import React, { useState, useEffect } from 'react';

import './styles.css';

import checkDeviceType from '../../../checkDeviceType';

import classServices from '../../../services/academy/classServices';
import reportServices from '../../../services/reportServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import SearchBar from '../../../components/SearchBar';
import { Link } from 'react-router-dom';
import ListOptions from '../../../components/ListOptions';
import ActivityIndicator from '../../../components/ActivityIndicator';
import ClassesGroup from './ClassesGroup';
import PopupClassesReports from './PopupClassesReports';
import { FaPlus, FaPrint } from 'react-icons/fa';

export default function Classes(props) {
    const [deviceType, setDeviceType] = useState(checkDeviceType());
    const [searchText, setSearchText] = useState('');
    const [optionInfos, setOptionInfos] = useState([]);
    const [classesList, setClassesList] = useState([]);
    const [auxClassesList, setAuxClassesList] = useState([]);
    const [popupClassesReportsVisible, setPopupClassesReportsVisible] = useState(false);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        window.addEventListener('resize', () => {
            setDeviceType(checkDeviceType())
        });

        readClasses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function readClasses() {
        const response = await classServices.getClasses();
        if (response.status === 200) {
            setClassesList(response.data);
            orderClasses(optionInfos[0], optionInfos[1], response.data);
        } else
            alert("Erro ao ler turmas, tente novamente!");

        setFetching(false);
    };

    useEffect(() => {
        if (classesList.length > 1)
            orderClasses(optionInfos[0], optionInfos[1]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [optionInfos]);

    function compare(a, b, invert = 0) {
        if (a === b) return 0;
        else if (a > b) return invert ? -1 : 1;
        else return invert ? 1 : -1;
    }

    function orderClasses(option, orderOption, array = auxClassesList, setArray = setAuxClassesList) {
        let auxList = array.slice();
        switch (option) {
            case 1:
                // Ordena pela quantidade de alunos
                auxList.sort((a, b) => compare(a.nome, b.nome));
                auxList.sort((a, b) => compare(a.numero_vagas - a.numero_alunos, b.numero_vagas - b.numero_alunos, orderOption));
                break;
            default:
                // Ordena pelo nome
                auxList.sort((a, b) => compare(a.nome, b.nome, orderOption));
                break;
        }
        setArray(auxList);
    }

    function searchClass(searchName, array = classesList) {
        let auxList = array.filter((item) => item.nome.toLowerCase().includes(searchName.toLowerCase()));
        orderClasses(optionInfos[0], optionInfos[1], auxList);
    }

    async function onDeleteClass(item) {
        if (auxClassesList.length) {
            let index = auxClassesList.indexOf(item);
            if (index > -1)
                setAuxClassesList([...auxClassesList.slice(0, index), ...auxClassesList.slice(index + 1, auxClassesList.length)]);
        }

        if (classesList.length) {
            let index = classesList.indexOf(item);
            if (index > -1)
                setClassesList([...classesList.slice(0, index), ...classesList.slice(index + 1, classesList.length)]);
        }
    }

    async function generateReport(fields = null, fileName) {
        console.log(fields);
        const data = new Date();
        const month = data.getMonth() + 1;
        const year = data.getFullYear();
        try {
            await reportServices.generateReportClasses(auxClassesList, `RELATÓRIO DE TURMAS DA ACADEMIA NO MÊS ${month} DE ${year}`, month, year, fields, fileName);
            return true;
        }
        catch (err) {
            alert(err.message);
            return false;
        }
    }

    function findAgeGroupIndex(array, ageGroup) {
        return array.findIndex((item) => {
            return item.ageGroup === ageGroup;
        });
    }

    function groupByAgeGroup(array) {
        return array.reduce((cache, item) => {
            const ageGroup = item.faixa_etaria;
            const index = findAgeGroupIndex(cache, ageGroup);
            if (index !== -1) {
                cache[index].classes.push(item);
            } else {
                cache.push({
                    ageGroup: ageGroup,
                    classes: [item]
                });
            }
            return cache;
        }, []).sort((a, b) => compare(Number(a.ageGroup.substring(4)), Number(b.ageGroup.substring(4))));
    }

    return (
        <MainView currentPage='classes' coachMenu={props.coachMode}>
            <NavHistory navPages={['Turmas']} />

            <div className='classes-page-options'>
                <SearchBar
                    placeholder={deviceType === 'phone' ? "Nome da turma" : "Digite o nome da turma"}
                    onChange={(event) => {
                        setSearchText(event.target.value);
                        if (event.target.value === "")
                            orderClasses(optionInfos[0], optionInfos[1], classesList);
                    }}
                    value={searchText}
                    onClick={() => searchClass(searchText)}
                />

                {
                    props.coachMode ?
                        [] :
                        <div className='classes-page-options-buttons'>
                            <Link to='/academia/turmas/cadastro' className='button new-class'>
                                {/* {deviceType === 'phone' ? <FaPlus /> : <>Nova turma<FaPlus /></>} */}
                                Nova turma<FaPlus />
                            </Link>

                            <button title="Gerar relatório" onClick={() => setPopupClassesReportsVisible(true)}><FaPrint /></button>
                            <PopupClassesReports
                                visibility={popupClassesReportsVisible}
                                setVisibility={setPopupClassesReportsVisible}
                                generateReport={generateReport}
                            />
                        </div>
                }
            </div>

            <div className='classes-page-list-infos'>
                <span>Exibindo {classesList.length} {classesList.length === 1 ? "turma" : "turmas"}</span>
                <div className='classes-page-list-options'>
                    <ListOptions
                        title='Ordenar'
                        options={["Nome", "Vagas"]}
                        isToOrder
                        setOptionInfos={setOptionInfos}
                    />
                </div>
            </div>

            {
                !fetching ?
                    <ul className='classes-page-list'>
                        {
                            classesList && classesList.length !== 0 ?
                                groupByAgeGroup(auxClassesList).map((group, index) =>
                                    <ClassesGroup
                                        key={Number(group.ageGroup.substring(4))}
                                        classesRef={group.ageGroup}
                                        classesData={group.classes}
                                        onDelete={onDeleteClass}
                                        coachMode={props.coachMode}
                                    />
                                )
                                : []
                        }
                    </ul>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}